export enum KbaOutcome{
  POSITIVE	= 0,
  NEGATIVE	= 1,
  NEGATIVE_WITH_RETRY = 2
}
